import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/product/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/product/';

class ProductService {
  getAll() {
    return axios.get(API_URL + `sorted`, { headers: authHeader() });
  }

  getAllPageable(name, page, pageSize) {
    return axios.get(API_URL + `all?name=${name}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `one/${id}`, { headers: authHeader() });
  }

  create(product) {
    return axios.post(API_URL + `cre`, {
      name: product.name,
      sv: product.sv,
      pv: product.pv,
      description: product.description,
      unitPrice: product.unitPrice,
      costPrice: product.costPrice
    }, { headers: authHeader() });
  }

  update(id, product) {
    return axios.put(API_URL + `upd/${id}`, {
        name: product.name,
        sv: product.sv,
        pv: product.pv,
        description: product.description,
        unitPrice: product.unitPrice,
        costPrice: product.costPrice
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getByName(name) {
    return axios.get(API_URL + `all?name=${name}`, { headers: authHeader() });
  }
}

export default new ProductService();